export default "__VITE_ASSET__cRFLG5li__"